<template>
  <div class="document-debtor">
    <DocumentTitle activeClass="mb-3">이용자 정보(본인)</DocumentTitle>
    <table>
      <tr>
        <td>대표자명</td>
        <td>{{ me.name }}</td>
      </tr>
      <tr>
        <td>생년월일</td>
        <td>{{ me.birthdate }}</td>
      </tr>
      <tr>
        <td>전화번호</td>
        <td>{{ me.phone }}</td>
      </tr>
      <tr>
        <td>사업자명</td>
        <td>{{ me.store.name }}</td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>{{ me.store.businessLicenseNumber }}</td>
      </tr>
      <tr>
        <td>주소</td>
        <td>{{ me.store.address1 }} {{ me.store.address2 }}</td>
      </tr>
    </table>
    <v-row no-gutters class="agree mt-3">
      <v-col cols="8">
        <p class="mb-0">이용자 정보에 대한 내용에</p>
      </v-col>

      <v-col cols="4" class="text-right">
        <button @click="isAgreed = !isAgreed" :class="{ active: isAgreed }">확인함</button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DocumentTitle from '@/components/documents/DocumentTitle.vue'
import { mapState } from 'vuex'

export default {
  components: {
    DocumentTitle,
  },
  data() {
    return {
      isAgreed: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
  },
  watch: {
    isAgreed(v) {
      this.$emit('emitAgreed', v)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document-debtor {
  table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600;
        font-size: 15px;
        line-height: 2.13;
        text-align: center;
        color: $black;
      }
      td:last-child {
        font-weight: 900;
        font-size: 16px;
        line-height: 2;
        text-align: center;
        color: $black;
      }
    }
  }
}
</style>
